// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-footer {
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  padding: 32px 0;
  margin-top: 60px;
  position: relative;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
}

/* 左侧链接区域 */
.footer-links-section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
}

.footer-link {
  color: #6c757d;
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
  padding: 4px 0;
  transition: all 0.3s ease;
  position: relative;
}

.footer-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 1px;
  background: #6C5CE7;
  transition: width 0.3s ease;
}

.footer-link:hover {
  color: #6C5CE7;
  transform: translateX(4px);
}

.footer-link:hover::after {
  width: 100%;
}

/* 右侧版权信息 */
.footer-copyright-section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  gap: 8px;
}

.company-info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.company-name {
  color: #495057;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.company-number {
  color: #6c757d;
  font-size: 12px;
  font-weight: 400;
}

.copyright-info {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #6c757d;
  font-size: 12px;
  font-weight: 400;
  justify-content: flex-end;
}

.copyright-info .anticon {
  font-size: 12px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .app-footer {
    padding: 24px 0;
    margin-top: 40px;
  }
  
  .footer-content {
    padding: 0 16px;
    flex-direction: column;
    gap: 24px;
    align-items: center;
  }
  
  .footer-links-section {
    align-items: center;
  }
  
  .footer-links {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 16px;
  }
  
  .footer-link {
    font-size: 13px;
  }
  
  .footer-copyright-section {
    align-items: center;
    text-align: center;
  }
  
  .company-info {
    align-items: center;
  }
  
  .company-name {
    font-size: 13px;
  }
  
  .company-number {
    font-size: 11px;
  }
  
  .copyright-info {
    font-size: 11px;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .app-footer {
    padding: 20px 0;
  }
  
  .footer-content {
    gap: 20px;
  }
  
  .footer-links {
    gap: 12px;
  }
  
  .footer-link {
    font-size: 12px;
  }
  
  .company-name {
    font-size: 12px;
  }
  
  .company-number {
    font-size: 10px;
  }
  
  .copyright-info {
    font-size: 10px;
  }
}

/* 动画效果 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.footer-links-section {
  animation: fadeInUp 0.6s ease-out;
}

.footer-copyright-section {
  animation: fadeInUp 0.6s ease-out 0.2s both;
}

/* 深色模式支持 */
@media (prefers-color-scheme: dark) {
  .app-footer {
    background: #1a1a1a;
    border-top-color: #333;
  }
  
  .footer-link {
    color: #a0a0a0;
  }
  
  .footer-link:hover {
    color: #6C5CE7;
  }
  
  .company-name {
    color: #e0e0e0;
  }
  
  .company-number,
  .copyright-info {
    color: #a0a0a0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/Footer.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA,WAAW;AACX;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA,WAAW;AACX;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA,UAAU;AACV;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,SAAS;AACT;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,WAAW;AACX;EACE;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,cAAc;EAChB;AACF","sourcesContent":[".app-footer {\n  background: #f8f9fa;\n  border-top: 1px solid #e9ecef;\n  padding: 32px 0;\n  margin-top: 60px;\n  position: relative;\n}\n\n.footer-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 40px;\n}\n\n/* 左侧链接区域 */\n.footer-links-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.footer-links {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: flex-start;\n}\n\n.footer-link {\n  color: #6c757d;\n  font-size: 14px;\n  font-weight: 400;\n  text-decoration: none;\n  padding: 4px 0;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.footer-link::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 0;\n  height: 1px;\n  background: #6C5CE7;\n  transition: width 0.3s ease;\n}\n\n.footer-link:hover {\n  color: #6C5CE7;\n  transform: translateX(4px);\n}\n\n.footer-link:hover::after {\n  width: 100%;\n}\n\n/* 右侧版权信息 */\n.footer-copyright-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  text-align: right;\n  gap: 8px;\n}\n\n.company-info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n}\n\n.company-name {\n  color: #495057;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.3px;\n}\n\n.company-number {\n  color: #6c757d;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.copyright-info {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #6c757d;\n  font-size: 12px;\n  font-weight: 400;\n  justify-content: flex-end;\n}\n\n.copyright-info .anticon {\n  font-size: 12px;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .app-footer {\n    padding: 24px 0;\n    margin-top: 40px;\n  }\n  \n  .footer-content {\n    padding: 0 16px;\n    flex-direction: column;\n    gap: 24px;\n    align-items: center;\n  }\n  \n  .footer-links-section {\n    align-items: center;\n  }\n  \n  .footer-links {\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 16px;\n  }\n  \n  .footer-link {\n    font-size: 13px;\n  }\n  \n  .footer-copyright-section {\n    align-items: center;\n    text-align: center;\n  }\n  \n  .company-info {\n    align-items: center;\n  }\n  \n  .company-name {\n    font-size: 13px;\n  }\n  \n  .company-number {\n    font-size: 11px;\n  }\n  \n  .copyright-info {\n    font-size: 11px;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .app-footer {\n    padding: 20px 0;\n  }\n  \n  .footer-content {\n    gap: 20px;\n  }\n  \n  .footer-links {\n    gap: 12px;\n  }\n  \n  .footer-link {\n    font-size: 12px;\n  }\n  \n  .company-name {\n    font-size: 12px;\n  }\n  \n  .company-number {\n    font-size: 10px;\n  }\n  \n  .copyright-info {\n    font-size: 10px;\n  }\n}\n\n/* 动画效果 */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.footer-links-section {\n  animation: fadeInUp 0.6s ease-out;\n}\n\n.footer-copyright-section {\n  animation: fadeInUp 0.6s ease-out 0.2s both;\n}\n\n/* 深色模式支持 */\n@media (prefers-color-scheme: dark) {\n  .app-footer {\n    background: #1a1a1a;\n    border-top-color: #333;\n  }\n  \n  .footer-link {\n    color: #a0a0a0;\n  }\n  \n  .footer-link:hover {\n    color: #6C5CE7;\n  }\n  \n  .company-name {\n    color: #e0e0e0;\n  }\n  \n  .company-number,\n  .copyright-info {\n    color: #a0a0a0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
